import { getSectionCover } from '../redux/actions/section-actions';

export default {
  actions: { getSectionCover },
};
